<div class="home-cont">
    <div class="home-cont-logos">
        <img [src]="'../../../assets/images/' + logo" alt="logo" [width]="logoWidth" />
    </div>
</div>